module.exports = __webpack_public_path__ + "static/media/play.81122af7.svg";